
const newModel = () => {
    return {
        toDanPhoId: null,
        ten: null,
        khomApId: null,
        tenKhomAp: null,
        phuongXaId: null,
        tenPhuongXa: null,
        tinhTpId: null,
        tenTinhTp: null,
        quanHuyenId: null,
        tenQuanHuyen: null,
        stt: null,
        enabled: null,
        enabledDisplay: null,
    }
}

const newFEModel = () => {
    return {
        toDanPhoId: null,
        ten: null,
        khomApId: null,
        tenKhomAp: null,
        phuongXaId: null,
        tenPhuongXa: null,
        tinhTpId: null,
        tenTinhTp: null,
        quanHuyenId: null,
        tenQuanHuyen: null,
        stt: null,
        enabled: null,
        enabledDisplay: null,
    }
}

const fromJson = (item) => {
    return {
        toDanPhoId: item.toDanPhoId,
        ten: item.ten,
        khomApId: item.khomApId,
        tenKhomAp: item.tenKhomAp,
        phuongXaId: item.phuongXaId,
        tenPhuongXa: item.tenPhuongXa,
        tinhTpId: item.tinhTpId,
        tenTinhTp: item.tenTinhTp,
        quanHuyenId: item.quanHuyenId,
        tenQuanHuyen: item.tenQuanHuyen,
        stt: item.stt,
        enabled: item.enabled,
        enabledDisplay: item.enabled == 1 ? true : false
    }
}

const parseModeltoFEModel = (item) => {
    return {
        toDanPhoId: item.toDanPhoId,
        ten: item.ten,
        khomApId: item.khomApId,
        tenKhomAp: item.tenKhomAp,
        phuongXaId: item.phuongXaId,
        tenPhuongXa: item.tenPhuongXa,
        tinhTpId: item.tinhTpId,
        tenTinhTp: item.tenTinhTp,
        quanHuyenId: item.quanHuyenId,
        tenQuanHuyen: item.tenQuanHuyen,
        stt: item.stt,
        enabled: item.enabled,
        enabledDisplay: item.enabled == 1 ? true : false
    }
}

const errors = () => {
    return {
        toDanPhoId: null,
        ten: null,
        khomApId: null,
        tenKhomAp: null,
        phuongXaId: null,
        tenPhuongXa: null,
        tinhTpId: null,
        quanHuyenId: null,
        stt: null,
        enabled: null,
        enabledDisplay: null
    }
}

export const toDanPhoModel = {
    newModel,
    newFEModel,
    parseModeltoFEModel,
    fromJson,
    errors,
}


